import React, { useState } from 'react';

/**
 * <DuotoneImage src={...} alt={...} />
 *
 * Static, lightweight sibling of <HeroImage>: same violet → electric duotone
 * treatment, no motion. Fills its parent (absolute inset-0), so the parent
 * sets size, radius and overflow. Pass `decorative` to hide it from screen
 * readers when it only sets mood.
 */
export function DuotoneImage({ src, alt = '', decorative = false, className = '', duotone = 0.5, testId }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`} data-testid={testId}>
      <div
        aria-hidden
        className="absolute inset-0"
        style={{
          background:
            'radial-gradient(circle at 30% 25%, rgba(108,92,231,0.35), transparent 55%), radial-gradient(circle at 80% 80%, rgba(75,159,255,0.25), transparent 55%), #0E0E15',
        }}
      />
      <img
        src={src}
        alt={decorative ? '' : alt}
        aria-hidden={decorative || undefined}
        onLoad={() => setLoaded(true)}
        loading="lazy"
        decoding="async"
        referrerPolicy="no-referrer"
        className="absolute inset-0 h-full w-full object-cover"
        style={{
          filter: 'grayscale(0.95) contrast(1.05) brightness(0.78)',
          opacity: loaded ? 1 : 0,
          transition: 'opacity 600ms ease',
        }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{ background: 'linear-gradient(135deg, #6C5CE7 0%, #4B9FFF 100%)', mixBlendMode: 'screen', opacity: duotone }}
      />
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, rgba(108,92,231,0.45) 0%, rgba(10,10,15,0.35) 60%, rgba(75,159,255,0.20) 100%)',
          mixBlendMode: 'multiply',
        }}
      />
    </div>
  );
}
